import React from 'react';
import Classes from 'classnames';

export default function SystemFieldStatusViewInImport(props) {

    const status = gd.session.statuses.get(props.value);

    return (
        <div className={Classes("ui5-pill-22 color","status-color-"+status.color)}>{status.name}</div>
    );
}